"use client"

import Image from "next/image"
import Link from "next/link"
import { Bookmark } from "lucide-react"
import type { BlogArticle } from "@/content/blog-shared"
import styles from "./blog.module.css"

export const BLOG_SAVED_KEY = "tipsitickets:blog:reading-list:v1"

export function trackArticleClick(slug: string) {
  void fetch("/api/blog/clicks", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ slug, eventId: crypto.randomUUID() }), credentials: "omit", keepalive: true }).catch(() => { /* Reading an article remains available if analytics is offline. */ })
}

export function ArticleCover({ article, priority = false }: { article: BlogArticle; priority?: boolean }) {
  return <Image src={article.image} alt={article.imageAlt} fill priority={priority} sizes={priority ? "(max-width: 760px) 100vw, 55vw" : "(max-width: 500px) 100vw, (max-width: 760px) 50vw, (max-width: 1199px) 33vw, 25vw"} className={styles.photo} style={{ objectPosition: article.imagePosition }} />
}

export function ArticleCard({ article, saved, ready, onSave }: { article: BlogArticle; saved: boolean; ready: boolean; onSave: () => void }) {
  return <article className={styles.card}>
    <Link href={article.href} className={styles.cardLink} aria-label={`Read ${article.title}`} onClick={() => trackArticleClick(article.slug)} onAuxClick={event => { if (event.button === 1) trackArticleClick(article.slug) }}>
      <div className={styles.cardImage}><ArticleCover article={article} /></div>
      <div className={styles.cardCopy}>
        <h3>{article.title}</h3>
        <div className={styles.cardDetails}><span className={styles.cardCategory}>{article.topic}</span><span className={styles.cardMeta}>{article.minutes} min read</span></div>
      </div>
    </Link>
    <button type="button" disabled={!ready} className={`${styles.saveButton} ${saved ? styles.isSaved : ""}`} aria-label={`${saved ? "Unsave" : "Save"} ${article.title}`} aria-pressed={saved} onClick={onSave} title={saved ? "Remove from reading list" : "Save for later"}>
      <Bookmark size={17} fill={saved ? "currentColor" : "none"} aria-hidden="true" />
    </button>
  </article>
}
